<template>
  <div class="score-chart">
    <div class="box box-primary">
      <div class="box-body">
        <h3 class="my-1">
          <i class="fa fa-cube mr-1"/> {{ scoreTypeDays }} day -
          {{ (scoreTypeLabel == 'crs scores' ? 'cs scores' : scoreTypeLabel) }} - store ranking
        </h3>

        <hr style="margin:10px 10px" />
        <div 
          v-for="(store, index) in sortedScores" 
          :key="index" 
          class="store-score-outer-wrapper">
          <div class="">
            <div
              v-for="(score, index) in store.scores"
              :key="index"
              class="store-score-inner-wrapper my-1">
              <div class="store-name m-2">
                <div class="d-flex flex-column align-center" style="overflow-y: hidden">
                  <div class="d-flex justify-center">
                    <h5 class="my-0 text-center">
                      <b>{{ store.storeName.toLowerCase() }}</b>
                    </h5>
                  </div>
                  <div
                    v-if="store.scores[0].feedbackIncluded > 0"
                    class="d-flex justify-center"
                    >
                    <div class="d-flex text-right" style="flex-grow: 0">
                      <span class="small">{{ formatDate(store.scores[0].endDate) }}</span>
                    </div>
                    <div class="d-flex ml-2 mr-2" style="flex-shrink: 0">
                      <span class="small"> through </span>
                    </div>
                    <div class="d-flex text-left" style="flex-grow: 0">
                      <span class="small">{{ formatDate(Date.now()) }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-center" v-else>
                    <span class="small mb-4">no feedback found in date range.</span>
                  </div>

                  <div class="d-flex justify-center">
                    <span class="small mb-4"> {{ store.scores[0].feedbackIncluded }} feedback </span>
                  </div>
                </div>
              </div>
              <div class="score-type">
                <progress-bar
                  v-model="score.score"
                  :type="progressBarFromScore(score.score)"
                />
              </div>
              <div
                class="score-score text-center"
                :class="{'bg-green': score.score >= 70,
                         'bg-yellow': score.score < 70 && score.score > 50,
                         'bg-red': score.score <= 50}">
                <h4>
                  <b>{{ score.score ? score.score.toFixed(2) : 0 }}</b>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProgressBar } from "uiv";
import { format, parseISO } from "date-fns";

export default {
  props: {
    //an array of store objects with  containing the storeName and scores[]
    storesScores: [Boolean, Array],
    sortOrder: {
      type: String,
      default: "DESC"
    },
    scoreType: {
      type: String,
      default: "nps"
    },
    scoreTypeDays: {
      type: Number,
      default: 7
    }
  },
  name: "ScoreRankingChart",
  components: {
    ProgressBar
  },
  computed: {
    sortedScores() {
      if (this.sortOrder == "ASC") return this.sortAsc;
      if (this.sortOrder == "DESC") return this.sortDesc;
    },
    sortAsc() {
      //since sorting mutates the object , so spread it to create new
      const sortedScores = [...this.storesScores].sort((a, b) => {
        //We only care about this sorting if one score type is included
        //so pull off the first one
        var comparision = 0;
        if (a.scores[0].score > b.scores[0].score) {
          comparision = 1;
        } else if (a.scores[0].score < b.scores[0].score) {
          comparision = -1;
        }
        return comparision;
      });
      return sortedScores;
    },
    sortDesc() {
      //since sorting mutates the object , so spread it to create new
      const sortedScores = [...this.storesScores].sort((a, b) => {
        //We only care about this sorting if one score type is included
        //so pull off the first one
        var comparision = 0;
        if (a.scores[0].score > b.scores[0].score) {
          comparision = -1;
        } else if (a.scores[0].score < b.scores[0].score) {
          comparision = 1;
        }
        return comparision;
      });
      return sortedScores;
    },
    scoreTypeLabel() {
      return `${this.scoreType} scores` || "false";
    }
  },
  methods: {
    formatDate(val = false) {
      let formattedDate = "n/a";
      if (val) formattedDate = new Date(val).toDateString().slice(4, 10).toLowerCase();

      return formattedDate;
    },
    progressBarFromScore(score) {
      if (score >= 70) return "success";
      if (score <= 50) return "danger";
      return "warning";
    }
  }
};
</script>
